import React from "react"
import { HiMiniQrCode } from "react-icons/hi2"

// Utility function to convert RGB to HEX
export const RgbToHex = (rgb: string): string => {
  const result = rgb.match(/\d+/g) // Extract the numbers from the rgb string
  if (!result || result.length !== 3) return rgb // Fallback if the format is incorrect

  const [r, g, b] = result.map(Number) // Convert strings to numbers
  return `#${((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1)
    .toUpperCase()}` // Convert to hex and format
}

type ColorPickerProps = {
  colors: string[] // Array of RGB colors in string format
  setColor: (color: string) => void // Function to set the selected color in the parent component
}

export const ColorPickerQrCode: React.FC<ColorPickerProps> = ({
  colors,
  setColor,
}) => {
  const handleColorClick = (color: string) => {
    const hexColor = RgbToHex(color) // Convert the color to HEX
    setColor(hexColor) // Pass HEX color to the parent
  }

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
      }}
    >
      {colors.map((color, index) => (
        <div
          key={index}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            border: "2px solid grey",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            cursor: "pointer",
            backgroundColor: RgbToHex(color), // Display original RGB color
          }}
          onClick={() => handleColorClick(color)}
        >
          <div
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "50%",
              backgroundColor: color, // Inner circle shows the original color
              flexShrink: 0,
              cursor: "pointer",
            }}
          >
            {" "}
            <span
              className=" text-white d-flex justify-content-center align-items-center "
              style={{ fontSize: "14px" }}
            >
              <HiMiniQrCode />
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}
